import React from 'react';
import Particles from 'react-particles-js';
import img from '../../images/particel.gif';

const ParticlesBackground = () => {
	return (
		<div>
			<Particles
				canvasClassName='example'
				height='270rem'
				width='100%'
				params={{
					particles: {
						number: {
							value: 80,
							density: {
								enable: true,
								value_area: 1803.4120608655228,
							},
						},
						color: {
							value: '#fff',
						},
						shape: {
							type: 'image',
							stroke: {
								width: 5,
								color: '#000000',
							},
							polygon: {
								nb_sides: 4,
							},
							image: {
								src: img,
								width: 200,
								height: 200,
							},
						},
						opacity: {
							value: 1,
							random: false,
							anim: {
								enable: false,
								speed: 0.5,
								opacity_min: 0.1,
								sync: false,
							},
						},
						size: {
							value: 10,
							random: true,
							anim: {
								enable: false,
								speed: 40,
								size_min: 0.1,
								sync: false,
							},
						},
						line_linked: {
							enable: true,
							distance: 0,
							color: '#ffffff',
							opacity: 0.3687847739990702,
							width: 0.6413648243462091,
						},
						move: {
							enable: true,
							speed: 2,
							direction: 'none',
							random: false,
							straight: false,
							out_mode: 'out',
							bounce: false,
							attract: {
								enable: false,
								rotateX: 600,
								rotateY: 1200,
							},
						},
					},
					interactivity: {
						detect_on: 'window',
						events: {
							onhover: {
								enable: true,
								mode: 'repulse',
							},
							onclick: {
								enable: false,
								mode: 'bubble',
							},
							resize: true,
						},
						modes: {
							grab: {
								distance: 400,
								line_linked: {
									opacity: 1,
								},
							},
							bubble: {
								distance: 400,
								size: 40,
								duration: 2,
								opacity: 8,
								speed: 3,
							},
							repulse: {
								distance: 100,
								duration: 0.4,
							},
							push: {
								particles_nb: 4,
							},
							remove: {
								particles_nb: 2,
							},
						},
					},
					retina_detect: true,
				}}
			/>
		</div>
	);
};

export default ParticlesBackground;
